import { Injector } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../Services/api.services';
import { Router } from '@angular/router';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { AppInsightsService } from 'src/app/Services/appInsight.service';
import { Seguro } from 'src/app/Models/seguro';
import { MiAutoInfo } from 'src/app/Models/MiAuto/MiAutoInfo';
import { GroupEvent } from 'src/app/Models/MiAuto/GroupEvent';

@Component({
  selector: 'app-auto',
  templateUrl: './auto.component.html',
  styleUrls: ['./auto.component.css']
})

export class AutoComponent implements OnInit {

  noData: boolean;
  isReady: boolean;
  asegurado: Asegurado;
  seguro: Seguro;
  loader: boolean;
  ultimaActualizacion: string;
  miAutoInfo: MiAutoInfo;
  listGroupEvent: GroupEvent[];

  constructor
  (private apiService: ApiService,
    private router: Router,
    private inj: Injector) {    
  }

  ngOnInit(): void {
    this.loader = true;
    this.asegurado = JSON.parse(localStorage.getItem('asegurado'));
    this.seguro = JSON.parse(localStorage.getItem('miSeguro'));
    
    let fechaHoy = new Date();
    const appInsightService = this.inj.get(AppInsightsService);
    appInsightService.logEvent(`Datos de MiAuto: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Fecha Hora: ${fechaHoy.toString()})`);

    this.apiService.ObtainDataCar(localStorage.getItem('firstIdVoucher')).subscribe((response: any) => {
      this.miAutoInfo = response;
      this.listGroupEvent = this.miAutoInfo.ReturnData;
      this.ultimaActualizacion = this.miAutoInfo.LastUpdate;
      this.noData = !this.miAutoInfo.ThereIsData;     
      this.loader = false;
    }, error => {
      this.handleOfferErrorTechniques(error);
    });
  }

  handleOfferErrorTechniques(error: any): void {
    this.router.navigate(['/errortechniques']);
  }
}
